import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import './HeaderSubtitle.scss';

const HeaderSubTitle = ({ children, className, ...props }) => {
    const classes = classnames(
        className,
        'text-center',
        'ml-header-subtitle',
    );

    return (
        <div className={classes} {...props}>
            { children }
        </div>
    );
};

HeaderSubTitle.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

export default HeaderSubTitle;
